import { useState, useEffect, useRef } from 'react'
import styled from "styled-components"
import { useRouter } from "next/router"
import findIndex from "lodash/findIndex"

import Stepper from '@rentspree/component-2023.components.organisms.stepper'
import Step from '@rentspree/component-2023.components.organisms.step'
import StepLabel from '@rentspree/component-2023.components.organisms.step-label'

export const ProgressBarV2Wrapper = styled.div`
  ${(props) => props.mt && `margin-top: ${props.mt}px`};
  ${(props) => props.mb && `margin-bottom: ${props.mb}px`};
  ${(props) => props.mr && `margin-right: ${props.mr}px`};
  ${(props) => props.ml && `margin-left: ${props.ml}px`};
  padding: 30px 50px 20px 50px;
  @media (max-width: 520px) {
    white-space: nowrap;
    overflow: auto;
    padding: 20px 20px 15px 20px;
    
  // hidden scroll bar
    ::-webkit-scrollbar {
      display: none;
    }
    -ms-overflow-style: none; 
    scrollbar-width: none;
  }
`

const ProgressBarV3 = ({ steps }) => {
  const [stepsState, setStepsState] = useState(steps)
  const [activeStep, setActiveStep] = useState(0)
  const router = useRouter()
  const scrollContainerRef = useRef(null)
  const stepperRef = {
    stepper0Ref: useRef(null),
    stepper1Ref: useRef(null),
    stepper2Ref: useRef(null)
  }

  const setStepPosition = (currentStepIndex) => {
    const step0Width = stepperRef.stepper0Ref.current.getBoundingClientRect().width
    const step1Width = stepperRef.stepper1Ref.current.getBoundingClientRect().width
    const refContainer = scrollContainerRef.current
    const distanceFromLeftToCenter = 40 + step0Width + (step1Width / 2)
    const scrollContainerWidth = refContainer.getBoundingClientRect().width
    let scrollToPosition = 0
    if (currentStepIndex == 1) {
      scrollToPosition = distanceFromLeftToCenter - (scrollContainerWidth / 2)
    } else if (currentStepIndex == 2) {
      scrollToPosition = 1000
    }
    refContainer.scrollTo({ left: scrollToPosition, behavior: "smooth" })
  }

  useEffect(() => {
    const currentStepIndex = findIndex(
      stepsState,
      (step) => router?.pathname === step?.pathname,
    )
    setStepPosition(currentStepIndex)
    setActiveStep(currentStepIndex)
    const steps = stepsState.map((step, index) => {
      if (index < currentStepIndex) {
        return { ...step, status: "complete" }
      } else if (index == currentStepIndex) {
        return { ...step, status: "active" }
      } else if (index > currentStepIndex) {
        return { ...step, status: "inactive" }
      }
      return step
    })

    setStepsState(steps)
  }, [stepperRef.stepper0Ref.current, stepperRef.stepper1Ref.current, stepperRef.stepper2Ref.current]);

  return (
    <ProgressBarV2Wrapper ref={scrollContainerRef} mr={10}>
      <Stepper style={{ marginRight: "50px" }} activeStep={activeStep} viewMode="mobile" >
        {stepsState.map((step, index) => {
          return (
            <Step key={`stepper-${index}`}>
              <span ref={stepperRef[`stepper${index}Ref`]}>
                <StepLabel status={step.status}>{step.label}</StepLabel>
              </span>
            </Step>
          )
        })}
      </Stepper>
    </ProgressBarV2Wrapper>
  )
}

export default ProgressBarV3
